<template>
  <div class="weight-loss-container">
    <div class="content-section">
      <h2 class="pb-2 border-bottom">Weight Management Programs</h2>
      <p>Safe, Supervised, and Personalized</p>
      <p>
        "At Diverse Care Now, we provide medically supervised weight management
        programs that combine modern medication with lifestyle support. Our goal
        is not just weight loss — it's building lasting health, balance, and
        confidence."
      </p>
      <h3>Sections</h3>
      <ul>
        <li>
          Medication Options — Physician-supervised medication therapies
          prescribed when appropriate, always under medical
          supervision.
        </li>
        <li>
          Personalized Plans — every patient receives a tailored approach based
          on health history, goals, and medical conditions.
        </li>
        <li>
          Nutrition & Lifestyle Support — guidance on meal planning, portion
          control, and healthy routines.
        </li>
        <li>
          Continuous Monitoring — monthly check-ins and dose adjustments to
          ensure safety and effectiveness.
        </li>
      </ul>
      <p>
        More than weight loss, our programs are designed to restore your health,
        energy, and confidence — under the guidance of our medical team.
      </p>
    </div>
    <div class="wl-videos">
      <iframe
        width="320"
        height="568"
        style="
          max-width: 100%;
          border-radius: 12px;
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
          margin-bottom: 1.5rem;
        "
        src="https://www.youtube.com/embed/L1P7TDXi-3g"
        title="YouTube Shorts: Weight Loss 1"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
      <iframe
        width="320"
        height="568"
        style="
          max-width: 100%;
          border-radius: 12px;
          box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
        "
        src="https://www.youtube.com/embed/VVgrgvhakKY"
        title="YouTube Shorts: Weight Loss 2"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen
      ></iframe>
    </div>
  </div>
</template>

<script>
export default {
  name: "WeightLossContentEn",
};
</script>

<style scoped>
.weight-loss-container {
  display: flex;
  gap: 2rem;
  align-items: flex-start;
}

.content-section {
  flex: 1;
  min-width: 0;
}

.wl-videos {
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.wl-videos iframe {
  width: 320px;
  height: 568px;
  max-width: 100%;
  border-radius: 12px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
}

/* Responsive design */
@media (max-width: 768px) {
  .weight-loss-container {
    flex-direction: column;
    gap: 1.5rem;
  }

  .wl-videos {
    align-self: center;
  }

  .wl-videos iframe {
    width: 280px;
    height: 497px;
  }
}

@media (max-width: 480px) {
  .wl-videos iframe {
    width: 240px;
    height: 426px;
  }
}
</style>
